<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" :modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <el-button type="primary" @click.native="add">新增</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column prop="hole_code" label="孔号" sortable="custom"></el-table-column>
                    <el-table-column prop="segment_no" label="段号" sortable="custom"></el-table-column>
                    <el-table-column prop="hole_code_relation" label="关联孔号" sortable="custom"></el-table-column>
                    <el-table-column prop="relation_type" label="关联方式" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.relation_type, "report_relation_type") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="relation_time" label="关联时间" sortable="custom"></el-table-column>
                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button  size="mini" plain type="danger" @click="del(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <Edit
            width="600px"
            title="添加关联关系"
            :report_id="report_id"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"
import { delData } from '@/api/common'
import Edit from "./edit"

export default {
    name: 'reportRelationList',
    mixins: [listutil],
    components: { Edit },
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        report_id: {
            type: Number,
            default() {
                return 0
            }
        },
    },
    watch: {
        isshow(newv) {
            this.showflag = newv;
            if (newv) {
                this.search_Obj.f_report_id = this.report_id;
                this.tableData = [];
                this.getData();
            }
        }
    },
    data() {
        return {
            showflag: false,
            m_name: '报告关联列表',
            menu_id: 9999,
            list_url: "/api/admin/reportrelation/list",
            search_Obj: {
                f_relation_type: '',
                f_report_id: '',
            },
            del_Obj:{
                url:'/api/admin/reportrelation/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['report_relation_type'],
        };
    },
    methods: {
        getData() {
            if (!this.search_Obj.f_report_id) {
                this.loading = false;
                this.tableData = [];
                return;
            }
            listutil.methods.getData.call(this);
        },
        closeDialog(){
            this.$emit("on-close")
        },
        add(){
            this.editshow = true
        },
        del(id) {
            this.$confirm('确定要删除该条数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del_Obj.data.ids = id
                const loading = this.$loading({
                    lock: true,
                    text: '正在执行...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                delData(this.del_Obj).then(res => {
                    loading.close()
                    if (res.code == 1) {
                        this.$msgs(res.msg)
                        this.getListData();
                    } else {
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => { })
        },
    }
};
</script>